import React from "react";
import PT from "prop-types";
import loadable from "@loadable/component";
import { connect } from "react-redux";
import { Actions as ModalActions } from "@/store/modals/slice";
import Modal from "_c/Modals";
import { usePreloadModules } from "@/hooks/usePreloadModules";

const ServiceEditor = loadable(
  () => import(/* webpackChunkName: "service-editor" */ "./main"),
  { ssr: false }
);
const preloadModules = [ServiceEditor];
const ServiceEditorModal = ({ isOpen, ...props }) => {
  usePreloadModules({ modules: preloadModules, delay: 1000 });
  return (
    <Modal onClose={props.onClose} isOpen={isOpen}>
      <ServiceEditor {...props} />
    </Modal>
  );
};
ServiceEditorModal.propTypes = {
  isOpen: PT.bool.isRequired,

  onClose: PT.func.isRequired,
};
const mDp = {
  openPremiumModal: ModalActions.openPremium,
};
export default connect(null, mDp)(ServiceEditorModal);
